module.exports = __webpack_public_path__ + "img/read-aloud-purple.f0b72e1d.svg";